import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireContract } from '~/utils/guards';

/** Layout route: all /onboarding/integration/meta/** require a LIVE meta-ads contract. */
export const Route = createFileRoute('/_authenticated/_tenant/onboarding/integration/meta')({
  beforeLoad: requireContract('meta', ['LIVE']),
  component: () => <Outlet />,
});
